import { action } from "mobx";
import { InputMode, PaneViewMode } from "../Types";
import {
  activePaneStates,
  inputModeComputed,
  paneKeyboardMappingAtom,
} from "./CanvasState";
import { FocusPaneEmitter } from "./FocusPane";
import { ParentComlinkAPI } from "./FrameSandboxAPI";
import { KeyboardCommandPriority, registerKeyboardCommand } from "./Keyboard";
import { reactionOnCondition } from "./SandboxUtils";

export function setPaneKeyboardMapping() {
  const mapping: { [paneId: string]: string } = {};
  let iter = "a".charCodeAt(0);
  for (const [paneId, activePaneState] of activePaneStates.entries()) {
    if (activePaneState.viewMode.get() !== PaneViewMode.Hidden) {
      mapping[paneId] = String.fromCharCode(iter);
      if (mapping[paneId] === "z") {
        break;
      }
      iter++;
    }
  }
  paneKeyboardMappingAtom.value = mapping;
}

export function setupFocusPaneKeyboard() {
  const unsubscribes = [
    registerKeyboardCommand({
      name: "enter pane selection",
      keys: ["f"],
      handler: action(() => {
        setPaneKeyboardMapping();
        ParentComlinkAPI.focusSandboxFrame();
      }),
    }),
    reactionOnCondition(
      () => inputModeComputed.get() === InputMode.PickFocusPane,
      action(() =>
        registerKeyboardCommand({
          name: "select pane",
          keys: "*",
          priority: KeyboardCommandPriority.High,
          modes: [InputMode.PickFocusPane],
          handler: action((key) => {
            if (paneKeyboardMappingAtom.value !== undefined) {
              const entry = Object.entries(paneKeyboardMappingAtom.value).find(
                ([paneId, k]) => k === key
              );
              if (entry !== undefined) {
                const [paneId] = entry;
                FocusPaneEmitter.emit("focus", { paneId });
              }
            }
            paneKeyboardMappingAtom.value = undefined;
          }),
        })
      )
    ),
  ];

  return () => {
    unsubscribes.forEach((unsubscribe) => unsubscribe());
  };
}
